// extracted by mini-css-extract-plugin
export default {"host":"style_host__7KR3p","icon":"style_icon__59R+2"};